// Отдельная копия от apps/bot/src/lib/money.ts — браузер не может импортить из bot-пакета напрямую.
// Если правишь — синхронизируй обе версии (CLAUDE.md §5: shared-пакет добавляем только когда есть real reuse,
// сейчас только эти ~30 строк → копия проще).

const MINOR_UNITS_PER_MAJOR: Record<string, bigint> = {
  UZS: 100n,
  USD: 100n,
  EUR: 100n,
  RUB: 100n,
};

function minorPerMajor(currency: string): bigint {
  return MINOR_UNITS_PER_MAJOR[currency.toUpperCase()] ?? 100n;
}

export function formatMinor(amount: bigint | string, currency: string): string {
  const n = typeof amount === 'string' ? BigInt(amount) : amount;
  const factor = minorPerMajor(currency);
  const decimals = String(factor).length - 1;
  const negative = n < 0n;
  const abs = negative ? -n : n;
  const whole = abs / factor;
  const frac = abs % factor;
  const wholeStr = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const fracStr =
    decimals > 0 && frac !== 0n
      ? `,${frac.toString().padStart(decimals, '0').replace(/0+$/, '')}`
      : '';
  return (negative ? '-' : '') + wholeStr + fracStr;
}

export function formatWithCurrency(amount: bigint | string, currency: string): string {
  const symbol = currency.toUpperCase() === 'UZS' ? 'сум' : currency.toUpperCase();
  return `${formatMinor(amount, currency)} ${symbol}`;
}

/**
 * «30 000» / «30000» / «30000.50» / «30000,50» → bigint в минимальных единицах.
 * null, если строка не похожа на сумму. Пробелы-разделители разрядов допустимы,
 * потому что именно так число выглядит после копирования из банка.
 */
export function parseAmountToMinor(raw: string): bigint | null {
  const cleaned = raw.replace(/\s/g, '').replace(',', '.');
  if (!/^\d+(\.\d{1,2})?$/.test(cleaned)) return null;
  const [intPart, fracPart = ''] = cleaned.split('.');
  const padded = (fracPart + '00').slice(0, 2);
  const combined = `${intPart}${padded}`.replace(/^0+/, '') || '0';
  return BigInt(combined);
}
